var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-window-item py-6 px-3 py-md-12 px-md-6 px-lg-12 v-window-item--active justify-center",staticStyle:{"min-width":"100%","height":"100%"}},[(_vm.contactId)?_c('router-view',{staticClass:"mx-auto v-sheet theme--light",staticStyle:{"min-width":"50%","max-width":"1230px"},attrs:{"isUnitaire":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }